import { Controller } from "@hotwired/stimulus"
import "./slide_panel_component.css"

export default class extends Controller {
  static targets = ["panel"]

  open() {
    this.panelTarget.classList.add("slide-panel--open")
    this._escHandler = (e) => { if (e.key === "Escape") this.close() }
    document.addEventListener("keydown", this._escHandler)
  }

  close() {
    this.panelTarget.classList.remove("slide-panel--open")
    if (this._escHandler) {
      document.removeEventListener("keydown", this._escHandler)
      this._escHandler = null
    }
  }

  closeOnOverlay(event) {
    if (event.target === this.panelTarget) this.close()
  }

  disconnect() {
    if (this._escHandler) {
      document.removeEventListener("keydown", this._escHandler)
    }
  }
}
